import { MASKS } from 'constants/defines';

export default {
  cpfNumber: MASKS.CPF,
};
